import { createApiActionTypes } from 'store';

export const GET_TEMPLATE_LIST = createApiActionTypes('GET_TEMPLATE_LIST');
export const DELETE_TEMPLATE = createApiActionTypes('DELETE_TEMPLATE');
export const POST_TEMPLATE = createApiActionTypes('POST_TEMPLATE');
export const POST_MINIMAL_TEMPLATE = createApiActionTypes(
	'POST_MINIMAL_TEMPLATE',
);
export const RESET_TEMPLATE_DELETED = 'RESET_TEMPLATE_DELETED';

export const GET_TEMPLATE_DATA = createApiActionTypes('GET_TEMPLATE_DATA');
export const PATCH_TEMPLATE_DATA = createApiActionTypes('PATCH_TEMPLATE_DATA');

export const RESET_IS_SERVICE_CREATED = 'RESET_IS_SERVICE_CREATED';
export const RESET_IS_CATEGORY_CREATED = 'RESET_IS_CATEGORY_CREATED';
export const RESET_TEMPLATE_DATA = 'RESET_TEMPLATE_DATA';
export const RESET_UPDATED_TEMPLATE = 'RESET_UPDATED_TEMPLATE';

export const RESET_MINIMAL_TEMPLATE = 'RESET_MINIMAL_TEMPLATE';

export const GET_CATEGORY_LIST = createApiActionTypes('GET_CATEGORY_LIST');
export const GET_PARTNER_CATEGORY_LIST = createApiActionTypes(
	'GET_PARTNER_CATEGORY_LIST',
);
export const GET_SA_TEMPLATE_PARTNER_CATEGORY_LIST = createApiActionTypes(
	'GET_SA_TEMPLATE_PARTNER_CATEGORY_LIST',
);
export const GET_CATEGORY_SHORT_LIST = createApiActionTypes(
	'GET_CATEGORY_SHORT_LIST',
);
export const RESET_PARTNER_CATEGORY_LIST = 'RESET_PARTNER_CATEGORY_LIST';
export const POST_CATEGORY = createApiActionTypes('POST_CATEGORY');
export const RESET_CATEGORY_LIST = 'RESET_CATEGORY_LIST';

export const POST_SERVICE = createApiActionTypes('POST_SERVICE');
export const PATCH_SERVICE = createApiActionTypes('PATCH_SERVICE');

export const POST_EXAMPLE = createApiActionTypes('POST_EXAMPLE');
export const PATCH_EXAMPLE = createApiActionTypes('PATCH_EXAMPLE');
export const DELETE_EXAMPLE = createApiActionTypes('DELETE_EXAMPLE');

export const RESET_TEMPLATES_ERROR = 'RESET_TEMPLATES_ERROR';

// SURVEY SCHEDULING
export const POST_SURVEY_SCHEDULING = createApiActionTypes('POST_SCHEDULING');
export const UPDATE_SURVEY_SCHEDULING = createApiActionTypes(
	'UPDATE_SURVEY_SCHEDULING',
);
export const GET_SURVEY_DATA = createApiActionTypes('GET_SURVEY_DATA');
export const GET_PLANNED_SURVEY_DATA = createApiActionTypes(
	'GET_PLANNED_SURVEY_DATA',
);
export const RESET_PLANNED_SURVEY = 'RESET_PLANNED_SURVEY';

export const GET_COMPANY_CLIENTS = createApiActionTypes('GET_COMPANY_CLIENTS');
export const GET_COMPANY_OFFICES = createApiActionTypes('GET_COMPANY_OFFICES');

export const GET_SURVEY_LIMITS = createApiActionTypes('GET_SURVEY_LIMITS');
export const GET_OFFICES_AND_LIMITS_DATA = createApiActionTypes(
	'GET_OFFICES_AND_LIMITS_DATA',
);
export const GET_SURVEY_ROLES = createApiActionTypes('GET_SURVEY_ROLES');

export const SET_SURVEY_DATA = 'SET_SURVEY_DATA';
export const RESET_SCHEDULING_ERROR = 'RESET_SCHEDULING_ERROR';
export const RESET_SCHEDULING = 'RESET_SCHEDULING';

export const RESET_PATCH_SERVICE = 'RESET_PATCH_SERVICE';

// SERVICES
export const RESET_SERVICES_ERROR = 'RESET_SERVICES_ERROR';

// ROLES
export const DELETE_SURVEY_ROLE = createApiActionTypes('DELETE_SURVEY_ROLE');
export const POST_SURVEY_ROLE = createApiActionTypes('POST_SURVEY_ROLE');
export const EDIT_SURVEY_ROLE = createApiActionTypes('EDIT_SURVEY_ROLE');
export const RESET_ROLES_ERROR = 'RESET_ROLES_ERROR';
